<template>
  <b-tab title="Penjaga">
    <br />
    <b-col sm="12" md="12">
      <transition name="fade">
        <b-card no-body>
          <b-collapse id="collapse1" visible>
            <b-tabs card pills vertical nav-wrapper-class="w-40" v-model="tabIndex[1]">
              <b-tab active>
                <template slot="title">
                  {{tabs[0]}}
                  <span v-if="PersonalDetailsFormCompleted">✔</span>
                  <span v-else class="text-danger">*</span>
                </template>
                <b-form class="col-md-12">
                  <PersonalDetails others="guardian" />
                </b-form>
              </b-tab>
              <b-tab v-if="RelationshipId != 16 && RelationshipId != 17">
                <template slot="title">{{tabs[1]}}
                  <span v-if="ContactDetailsFormCompleted">✔</span>
                  <span v-else class="text-danger">*</span>
                </template>
                <b-form class="col-md-12">
                  <ContactDetails others="guardian" />
                </b-form>
              </b-tab>
              <div v-if="$ProgramIdMESH != ProgrammeId">
                <b-tab v-if="RelationshipId != 16 && RelationshipId != 17">
                  <template slot="title">
                    {{tabs[2]}}
                    <span v-if="EmploymentFormCompleted">✔</span>
                    <span v-else class="text-danger">*</span>
                  </template>
                  <b-form class="col-md-12">
                    <EmploymentDetails others="guardian" />
                  </b-form>
                </b-tab>
              </div>
            </b-tabs>
          </b-collapse>
        </b-card>
      </transition>
    </b-col>
  </b-tab>
</template>

<script>
import PersonalDetails from "./OthersPersonalDetails";
import EmploymentDetails from "./OthersEmploymentDetails";
import ContactDetails from "./ContactDetails";

export default {
  name: "Guardian",
  components: {
    PersonalDetails,
    EmploymentDetails,
    ContactDetails
  },
  data: function() {
    return {
      tabIndex: [0, 0],
      tabs: [
        "Butiran Peribadi Penjaga",
        "Maklumat Untuk Dihubungi",
        "Pekerjaan"
      ]
    };
  },
  computed: {
    RelationshipId: {
      get: function() {
        return this.$store.getters["appPersonalDetails/Relationship"];
      },
      set: function(value) {
        this.$store.dispatch("appPersonalDetails/updateRelationship", value);
      }
    },
    PersonalDetailsFormCompleted: {
      get: function() {
        return this.$store.getters["guardianPersonalDetails/FormCompleted"];
      }
    },
    ContactDetailsFormCompleted: {
      get: function() {
        return this.$store.getters["guardianContactDetails/FormCompleted"];
      }
    },
    EmploymentFormCompleted: {
      get: function() {
        return this.$store.getters["guardianEmploymentDetails/FormCompleted"];
      }
    },
    ProgrammeId: {
      get: function() {
        return this.$store.getters["appProposedStudy/Programme"];
      },
    },
  }
};
</script>
